import type { UiConfigInput } from './schema';

/**
 * Site-wide UI configuration.
 *
 * This object is the capability ceiling for the whole interface. Components read
 * `features.*` to decide whether to *mount* a feature, not to style it. When
 * `coordinates` is false the coordinate readout is never rendered, never
 * subscribed to and never updated, rather than being hidden with CSS.
 *
 * A map's own `features` block can narrow these further, but can never switch on
 * something that is off here. That keeps a per-map override from re-enabling a
 * feature an operator deliberately turned off site-wide (a fullscreen toggle on a
 * read-only kiosk map, for example).
 */
export const ui: UiConfigInput = {
	features: {
		sidebar: true,
		mapSelector: true,
		search: true,
		coordinates: true,
		compass: true,
		zoomControls: true,
		orientationControls: true,
		fullscreen: true,
		playerList: true,
		markerPanel: true,
		mobileControls: true,
		dimensionSwitcher: true,
		minimapMode: false
	},

	layout: {
		sidebarSide: 'left',
		sidebarWidth: '20rem',
		/** On phones the sidebar becomes a sheet that never covers the map permanently. */
		mobilePresentation: 'bottom-sheet',
		mapFullBleed: true
	},

	mapSelector: {
		/** Below seven selectable maps a search box is noise; this is the crossover. */
		searchThreshold: 6,
		showCategories: true,
		showDescriptions: true,
		showIcons: true,
		layout: 'list'
	},

	search: {
		coordinates: true,
		markers: true,
		players: true,
		placeholder: 'Search maps, markers, players or coordinates…',
		debounceMs: 200
	}
};
